import React from 'react';
import { Paper, Grid, Typography, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SkeletonTable: React.FC = () => {
    const { t: translate } = useTranslation('customer-settings');

    return (
        <Paper
            variant="outlined"
            sx={{
                borderRadius: 2,
                overflow: 'hidden',
                borderColor: '#d1d5db',
            }}
        >
            {/* Header */}
            <Grid
                container
                sx={{
                    bgcolor: '#1565c0',
                    color: 'white',
                    px: 2,
                    py: 1.25,
                    fontWeight: 600,
                }}
            >
                <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle2">{translate('SETTING')}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="subtitle2">{translate('DESCRIPTION')}</Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography variant="subtitle2">{translate('DEFAULT_VALUE')}</Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle2">{translate('SET_VALUE')}</Typography>
                </Grid>
            </Grid>

            {/* Skeleton rows */}
            {[...Array(5)].map((_, idx) => (
                <Grid container key={idx} alignItems="center" sx={{ px: 2, py: 1.25, borderTop: '1px solid #e5e7eb' }}>
                    <Grid item xs={12} sm={3}>
                        <Skeleton variant="text" width="80%" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Skeleton variant="text" width="95%" />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Skeleton variant="text" width="60%" />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Skeleton variant="rectangular" height={36} width="90%" />
                    </Grid>
                </Grid>
            ))}
        </Paper>
    );
};

export default SkeletonTable;
